/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'pacman': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M30.148 5.588A15.964 15.964 0 0018 0C9.163 0 2 7.163 2 16s7.163 16 16 16c4.86 0 9.213-2.167 12.148-5.588L20 16 30.148 5.588zM22 3.769a2.231 2.231 0 110 4.462 2.231 2.231 0 010-4.462z"/>'
  }
})
